import PeSingleChoice from '../../components/PeSingleChoice';
import PeProductChoice from '../../components/PeProductChoice';
import PePricingOverview from '../../components/PePricingOverview';
import PeMoreInfo from '../../components/PeMoreInfo';

const options = {
  yes_no: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ],
};

export const productChoiceStepField = [
  {
    name: 'pricing',
    dependOn: 'pe_installation',
    component: PeProductChoice,
    props: {
        label: 'Installation unit:',
        required: true,
    },
  },
  {
    name: "indicative_pricing",
    dependOn: "pricing",
    component: PeSingleChoice,
    props: {
      label: "Ready for indicative pricing?",
      required: true,
      options: options.yes_no,
      sm: 2,
    },
  },
  {
    name: 'product_choice',
    dependOn: "indicative_pricing",
    dependOnValue: "yes",
    component: PePricingOverview,
    props: {
        label: 'Pricing overview:',
        required: false,
    },
  },
  {
    name: "indicative_no_moreinfo",
    dependOn: "indicative_pricing",
    dependOnValue: "no",
    component: PeMoreInfo,
    props: {
      button: {
        label: "Get Free Quote",
        link: "#",
      },
      type: "warn",
      label: "Please get in touch by filling our get a free quote page, or alternatively email us info@pure-electric.com.au or give us a call 1300 86 78 73",
    },
  },
];
